import { createContext } from "react";
import { PanelType } from "../PanelType";

export type ActivePanelTypeContext = [
  key0: PanelType,
  key1: (arg0: PanelType) => void
];

export const ActivePanelTypeContext = createContext<ActivePanelTypeContext>([
  PanelType.None,
  () => {},
]);
